import IconSVG from "../../styles/svg-icons";
import { OnHoverTooltip } from "../common";

export function InventoryColumnLabel() {
    return (
        <OnHoverTooltip overlay="Click on ‘View’ to see this security in the Dealer Inventory">
            Inventory
            <IconSVG name="info" width={16} height={16} />
        </OnHoverTooltip>
    )
}